import React from 'react';

function OptionType({ icon, title, ...otherProps }) {
    return (
        <button { ...otherProps } className="relative outline-none select-none h-[293px] border border-[#EAEAEA] rounded-xl bg-[#FFFFFF] hover:bg-[#EFEFEF] flex items-center justify-center">
            <div className="w-[100px] h-[100px] flex items-center justify-center">
                <img src={icon} alt="" />
            </div>

            <h1 className='font-semibold text-[20px] leading-8 text-[#121212] absolute bottom-6 left-1/2 -translate-x-1/2 text-nowrap'>{title}</h1>
        </button>
    );
}

export default OptionType;
